module.exports = __webpack_public_path__ + "static/media/como-35.ef6d8401.jpg";